import type {
  OneTimePaymentAmountDetailsInterface,
  RentAmountDetailsInterface,
  RenterPaymentMethodInterface,
} from './Types';

const RentAmountDetails = (rentAmountDetails: RentAmountDetailsInterface) => {
  return {
    rentAmount: rentAmountDetails.rentAmount,
    totalAmount: rentAmountDetails.totalAmount,
    fee: rentAmountDetails.fee,
  };
};

const OneTimePaymentAmountDetails = (oneTimePaymentAmountDetails: Array<OneTimePaymentAmountDetailsInterface>) => {
  return oneTimePaymentAmountDetails.map((oneTimePaymentAmountDetail) => {
    return {
      groupKey: oneTimePaymentAmountDetail.groupKey,
      baseAmount: oneTimePaymentAmountDetail.baseAmount,
      fee: oneTimePaymentAmountDetail.fee,
      totalAmount: oneTimePaymentAmountDetail.totalAmount,
    };
  });
};

export default (paymentMethods: Array<RenterPaymentMethodInterface>) =>
  paymentMethods.map((paymentMethod) => {
    const {
      accountLast4 = '',
      id = '',
      nickname = '',
      displayName = '',
      accountType = '',
      paymentMethodStatus = '',
      isBankAccountVerificationNeeded = false,
      rentAmountDetails = { fee: 0, rentAmount: 0, totalAmount: 0 },
      oneTimePaymentAmountDetails = [],
      createdAt = '',
      bankName = '',
    } = paymentMethod;

    return {
      accountLast4,
      accountType,
      displayName,
      id,
      nickname,
      paymentMethodStatus,
      isBankAccountVerificationNeeded,
      rentAmountDetails: RentAmountDetails(rentAmountDetails),
      oneTimePaymentAmountDetails: OneTimePaymentAmountDetails(oneTimePaymentAmountDetails),
      createdAt,
      bankName,
    };
  });
